import React, { useState } from "react";

export const EditableCell = ({ value, userId, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");

  const handleBlur = () => {
    setEditing(false);
    if (inputValue !== value) {
      onSave(userId, inputValue);
    }
  };

  return editing ? (
    <input
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onBlur={handleBlur}
      autoFocus
      className="form-control form-control-sm"
    />
  ) : (
    <span
      className="cursor-pointer text-primary"
      onClick={() => setEditing(true)}
    >
      {value || "➕ Add Actual Name"}
    </span>
  );
};
